import { Section } from '@shared/Section'
import { faqs } from '@features/landing/content'

export function Faq() {
  return (
    <Section id="faq" eyebrow="FAQ" title="The questions that come up first">
      <div className="mx-auto max-w-3xl divide-y divide-black/10 dark:divide-white/[0.08]">
        {faqs.map((faq) => (
          <details key={faq.question} className="group py-5">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-base font-semibold text-foreground">
              {faq.question}
              <span
                aria-hidden
                className="shrink-0 text-xl leading-none text-muted-foreground transition-transform group-open:rotate-45"
              >
                +
              </span>
            </summary>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{faq.answer}</p>
          </details>
        ))}
      </div>
    </Section>
  )
}
